import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  file?: File;
}

function File({ file }: Props) {
  return (
    <Box w="400px" textAlign="center" mt={10}>
      <Heading as="h4" fontSize="large" mb={2}>
        Selected File:
      </Heading>
      {!file && <Text>Please upload a file above</Text>}
      {file && (
        <Flex align="center" justify="center">
          <FontAwesomeIcon icon={['fal', 'file-arrow-up']} size="lg" />
          <Text ml={2}>{file.name}</Text>
        </Flex>
      )}
    </Box>
  );
}

export default File;
